import React, {useRef, useCallback} from "react";
import { useNavigate } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Translation as T} from "@awe-web/shared/lib";
import {
  ScreenSection,
  ScreenHeadingWithSupplement,
  ScreenSectionHeading,
  ScreenLoading
} from "../../../components/screen.js";
import {Filter} from "../../../components/filter.js";
import {TypeArea} from "../../../components/layout.js";
import {RentObjectCardList} from "../../../rent_objects/components/rent_object_card";
import SelectedStationAndTime from "../../../stations/components/selected_station_and_time.jsx";
import {getGroupedRentObjectsB2C, getRentObjectGroupsB2C} from "../../../rent_objects/store.js";
import { useInitializeFromState } from "../../shared/actions.js";
import {initialize, selectRentObject} from "./actions.js";

import "./select_rent_object.scss";

const SELECT_RENT_OBJECT = "FSD0000114";
const LTR_NOTICE = "ALG0000263";
const PRICES_NOTICE = "ALG0000244";

function InternalSelectRentObject({onSubmit}) {
  const groupedRentObjects = useSelector((state) => getGroupedRentObjectsB2C(state));
  const rentObjectGroups = useSelector((state) => getRentObjectGroupsB2C(state));
  
  const rentObjectCardListRef = useRef();
  
  const handleFilterSelect = useCallback((event) => {
    const {target: {value}} = event;
    rentObjectCardListRef.current.scrollToCard(value);
  }, []);

  return (
    <ScreenSection main light>
      <TypeArea>
        <ScreenHeadingWithSupplement heading={<T code={SELECT_RENT_OBJECT} />}>
          <Filter rentObjectGroups={rentObjectGroups.toJS()} onSelect={handleFilterSelect} />
        </ScreenHeadingWithSupplement>

        <ScreenSectionHeading light>
          <T code={LTR_NOTICE} />
        </ScreenSectionHeading>

        <RentObjectCardList
          ref={rentObjectCardListRef}
          groupedRentObjects={groupedRentObjects.toJS()}
          selectedBasicProperties="B2C"
          onSelectedRentObject={onSubmit}
        />

        <div className="b2c-ltr-select-rent-object__prices-notice">
          <T code={PRICES_NOTICE} />
        </div>
      </TypeArea>
    </ScreenSection>
  );
}

export default function B2C_LTR_SelectRentObject() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = useCallback(async (classificationId) => {
    if (!classificationId) {
      return;
    }
    const gotoRoute = await dispatch(selectRentObject(classificationId));
    navigate(gotoRoute);
  }, [dispatch, navigate]);

  const init = useCallback(async () => {
    const redirectPath = await dispatch(initialize());

    if (redirectPath && redirectPath.length > 0) {
      navigate(redirectPath);
    }
  }, [dispatch, navigate]);

  const isReady = useInitializeFromState(init);
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div className="b2c-ltr-select-rent-object">
      <ScreenSection dark>
        <TypeArea>
          <SelectedStationAndTime
            reservationPath="B2C"
            withEditButton={true}
          />
        </TypeArea>
      </ScreenSection>

      <InternalSelectRentObject onSubmit={onSubmit} />
    </div>
  );
}
